export default "__VITE_ASSET__79b24049__"